import React from "react";
import HttpRequest from "helper-xhr";

class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  };

  handleClick = (e) => {
  }

  render() {
    var pages = [];
    this.props.pages.forEach((p, i) => {
      switch (p.label) {
        //case "prev":
        //  pages.push(<li key={"page-"+i} className="page-item"><a className="page-link" href="#">Precedente</a></li>);
        //  break;
        //case "next":
        //  pages.push(<li key={"page-" + i} className="page-item"><a className="page-link" href="#">Successiva</a></li>);
        //  break;
        case "page":
          pages.push(<li key={"page-" + i} className="page-item"><a className="page-link" href="#">{p.pagenr}</a></li>);
          break;
      }
    });

    return (
      <div>
        <nav>
          <ul className="pagination">
            {pages}
          </ul>
        </nav>
      </div>
    );
  }
}

export { Pagination };